export const SITE = {
  name: 'Skin by Lizzy',
  url: 'https://www.skinbylizzy.com',
  tagline: 'Calm, personalized skin care',
  // Online booking (PocketSuite). bookingUrl = full page; bookingEmbedUrl = the inline widget view used on /book.
  bookingUrl: 'https://pocketsuite.io/book/skinbylizzy',
  bookingEmbedUrl: 'https://pocketsuite.io/book/skinbylizzy?mode=inline',
  phone: '(720) 937-0243',
  email: 'lizzy@skinbylizzy.com',
  address: ['10325 W Glennon Dr.', 'Lakewood, CO 80226'],
  addressParts: { street: '10325 W Glennon Dr.', city: 'Lakewood', region: 'CO', postalCode: '80226' },
  hours: [
    { days: 'Tuesday – Friday', time: '10am – 6pm' },
    { days: 'Saturday', time: '9am – 3pm' },
    { days: 'Sunday – Monday', time: 'Closed' },
  ],
  social: [
    { label: 'Instagram', href: 'https://instagram.com/' },
    { label: 'Facebook', href: 'https://facebook.com/' },
  ],
};

export const NAV = [
  { to: '/', label: 'Home' },
  { to: '/treatments', label: 'Treatments' },
  { to: '/products', label: 'Products' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/about', label: 'About' },
  { to: '/contact', label: 'Contact' },
];
